import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
`;

export const Banner = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
`;

export const Text = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    text-align: left;
    color: #040222;
    margin-top: 12px;
`;

export const ButtonContainer = styled.div`
    width: 100%;
    display: grid;
    place-items: center;
    margin-top: 12px;
`;

export const BoldText = styled.div`
    display: flex;
    align-items: center;

    font-weight: 600;
    font-size: 22px;
    line-height: 22px;
    text-align: left;
    color: #040222;
    margin-top: 12px;
`;
